export default "/_next/static/videos/3c39438b98118c4ea383ea7947e4b940.mp4";